(function () {
  if (window.GSMaterialCheck) return;

  var STORAGE_KEY = 'gs-material-check';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l4 4L19 7"/></svg>';

  function readStorage() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function writeStorage(value) {
    try {
      if (value) window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      else window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function announce(match) {
    window.GSMaterialMatch = match;
    document.querySelectorAll('[data-gs-match-key]').forEach(function (el) {
      el.classList.toggle('is-match', !!match && el.getAttribute('data-gs-match-key') === match.key);
    });
    document.querySelectorAll('[data-gs-match-cta]').forEach(function (el) {
      if (!el.hasAttribute('data-default-text')) {
        el.setAttribute('data-default-text', el.textContent);
        el.setAttribute('data-default-href', el.getAttribute('href') || '#');
      }
      if (match) {
        el.textContent = (el.getAttribute('data-gs-match-cta') || '[material]').replace('[material]', match.name);
        if (match.url) el.setAttribute('href', match.url);
      } else {
        el.textContent = el.getAttribute('data-default-text');
        el.setAttribute('href', el.getAttribute('data-default-href'));
      }
    });
    document.dispatchEvent(new CustomEvent('gs:material-match', { detail: match }));
  }

  function MaterialCheck(root) {
    this.root = root;
    var configEl = root.querySelector('[data-gs-mc-config]');
    try {
      this.config = JSON.parse(configEl ? configEl.textContent : '{}');
    } catch (e) {
      this.config = {};
    }
    this.config.answers = this.config.answers || {};
    this.config.materials = this.config.materials || {};
    this.config.weights = this.config.weights || [2, 2, 1];
    this.answers = {};
    this.step = 1;
    this.bind();
    this.restore();
  }

  MaterialCheck.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var answer = event.target.closest('[data-gs-mc-answer]');
      if (answer) return self.pick(answer);
      if (event.target.closest('[data-gs-mc-back]')) return self.go(Math.max(1, self.step - 1));
      if (event.target.closest('[data-gs-mc-restart]')) return self.restart();
      var play = event.target.closest('[data-gs-mc-play]');
      if (play) return self.playVideo(play.closest('[data-gs-mc-video]'));
      var close = event.target.closest('[data-gs-mc-close]');
      if (close) return self.stopVideo(close.closest('[data-gs-mc-video]'));
    });
  };

  MaterialCheck.prototype.restore = function () {
    if (window.Shopify && window.Shopify.designMode) return;
    var saved = readStorage();
    if (!saved || !saved.answers) return;
    var valid = [1, 2, 3].every(
      function (q) {
        var a = this.config.answers[saved.answers[q]];
        return a && a.question === q;
      }.bind(this)
    );
    if (!valid) return writeStorage(null);
    this.answers = saved.answers;
    [1, 2, 3].forEach(this.markStep.bind(this));
    this.showResult(false);
  };

  MaterialCheck.prototype.pick = function (button) {
    var id = button.getAttribute('data-gs-mc-answer');
    var data = this.config.answers[id];
    if (!data) return;
    this.answers[data.question] = id;
    this.markStep(data.question);
    if (data.question < 3) this.go(data.question + 1);
    else this.showResult(true);
  };

  MaterialCheck.prototype.markStep = function (q) {
    var step = this.root.querySelector('[data-gs-mc-step="' + q + '"]');
    if (!step) return;
    var chosen = this.answers[q];
    step.querySelectorAll('[data-gs-mc-answer]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-gs-mc-answer') === chosen ? 'true' : 'false');
    });
  };

  MaterialCheck.prototype.hideAll = function () {
    this.root.querySelectorAll('[data-gs-mc-step], [data-gs-mc-result]').forEach(function (el) {
      el.hidden = true;
    });
    this.root.querySelectorAll('[data-gs-mc-video].is-playing').forEach(this.stopVideo.bind(this));
  };

  MaterialCheck.prototype.go = function (q) {
    this.step = q;
    this.hideAll();
    var step = this.root.querySelector('[data-gs-mc-step="' + q + '"]');
    if (step) step.hidden = false;
    this.keepInView();
    var first = step && (step.querySelector('[aria-pressed="true"]') || step.querySelector('[data-gs-mc-answer]'));
    if (first && document.activeElement && this.root.contains(document.activeElement)) first.focus({ preventScroll: true });
  };

  MaterialCheck.prototype.restart = function () {
    this.match = null;
    writeStorage(null);
    this.toggleDoubt(null);
    announce(null);
    this.go(1);
  };

  MaterialCheck.prototype.score = function () {
    var self = this;
    var totals = {};
    var order = [];
    Object.keys(this.config.materials).forEach(function (key) {
      totals[key] = 0;
    });
    [2, 1, 3].forEach(function (q) {
      var a = self.config.answers[self.answers[q]];
      if (a && order.indexOf(a.material) === -1) order.push(a.material);
    });
    Object.keys(totals).forEach(function (key) {
      if (order.indexOf(key) === -1) order.push(key);
    });
    [1, 2, 3].forEach(function (q) {
      var a = self.config.answers[self.answers[q]];
      if (a && totals.hasOwnProperty(a.material)) totals[a.material] += Number(self.config.weights[q - 1]) || 1;
    });
    var ranked = order.filter(function (key) {
      return totals.hasOwnProperty(key);
    });
    ranked.sort(function (x, y) {
      return totals[y] - totals[x] || order.indexOf(x) - order.indexOf(y);
    });
    var winner = ranked[0];
    var runnerUp = ranked[1] && totals[ranked[1]] > 0 ? ranked[1] : null;
    if (!runnerUp && winner) {
      var fallback = this.config.materials[winner].fallback;
      runnerUp = fallback && fallback !== winner && this.config.materials[fallback] ? fallback : ranked[1] || null;
    }
    return { winner: winner, runnerUp: runnerUp };
  };

  MaterialCheck.prototype.showResult = function (scroll) {
    var result = this.score();
    var material = this.config.materials[result.winner];
    var panel = this.root.querySelector('[data-gs-mc-result="' + result.winner + '"]');
    if (!material || !panel) return this.go(1);

    this.step = 4;
    this.hideAll();
    panel.hidden = false;
    this.fillText(panel, material);
    this.fillPills(panel);

    this.match = { key: result.winner, name: material.name, url: material.url };
    this.toggleDoubt(result.runnerUp ? this.config.materials[result.runnerUp] : null);
    writeStorage({ answers: this.answers, match: result.winner });
    announce(this.match);
    if (scroll) this.keepInView();
  };

  MaterialCheck.prototype.fillText = function (panel, material) {
    var el = panel.querySelector('[data-gs-mc-text]');
    if (!el) return;
    var phrases = [1, 2, 3].map(
      function (q) {
        var a = this.config.answers[this.answers[q]];
        return a ? a.phrase : '';
      }.bind(this)
    );
    var parts = [];
    if (phrases.every(Boolean) && this.config.sentence) {
      parts.push(
        this.config.sentence.replace('[1]', phrases[0]).replace('[2]', phrases[1]).replace('[3]', phrases[2])
      );
    }
    if (material.advice) parts.push(material.advice);
    el.textContent = parts.join(' ');
  };

  MaterialCheck.prototype.fillPills = function (panel) {
    var wrap = panel.querySelector('[data-gs-mc-pills]');
    if (!wrap) return;
    wrap.innerHTML = '';
    [1, 2, 3].forEach(
      function (q) {
        var a = this.config.answers[this.answers[q]];
        if (!a) return;
        var pill = document.createElement('span');
        pill.className = 'gs-mc__pill';
        pill.innerHTML = CHECK_SVG;
        var long = document.createElement('span');
        long.className = 'gs-mc__pill-long';
        long.textContent = a.pill;
        var short = document.createElement('span');
        short.className = 'gs-mc__pill-short';
        short.textContent = a.pillMobile || a.pill;
        pill.appendChild(long);
        pill.appendChild(short);
        wrap.appendChild(pill);
      }.bind(this)
    );
  };

  MaterialCheck.prototype.toggleDoubt = function (material) {
    var link = this.root.querySelector('[data-gs-mc-doubt]');
    if (!link) return;
    var text = link.querySelector('[data-gs-mc-doubt-text]');
    if (material && text) {
      text.textContent = (text.getAttribute('data-template') || '').replace('[material]', material.name);
      link.hidden = false;
    } else {
      link.hidden = true;
    }
  };

  MaterialCheck.prototype.keepInView = function () {
    var top = this.root.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.5) {
      var offset = parseInt(getComputedStyle(this.root).scrollMarginTop, 10) || 0;
      window.scrollTo({ top: window.pageYOffset + top - offset, behavior: 'smooth' });
    }
  };

  MaterialCheck.prototype.playVideo = function (wrap) {
    if (!wrap) return;
    var template = wrap.querySelector('[data-gs-mc-video-template]');
    var thumb = wrap.querySelector('[data-gs-mc-play]');
    var close = wrap.querySelector('[data-gs-mc-close]');
    if (!template) return;
    var video = template.content.querySelector('video');
    if (!video) return;
    var clone = video.cloneNode(true);
    clone.setAttribute('playsinline', '');
    wrap.insertBefore(clone, close);
    wrap.classList.add('is-playing');
    if (thumb) thumb.hidden = true;
    if (close) close.hidden = false;
    var attempt = clone.play();
    if (attempt && attempt.catch) attempt.catch(function () {});
    clone.focus({ preventScroll: true });
  };

  MaterialCheck.prototype.stopVideo = function (wrap) {
    if (!wrap) return;
    wrap.querySelectorAll('video').forEach(function (v) {
      if (v.closest('template')) return;
      v.pause();
      v.remove();
    });
    wrap.classList.remove('is-playing');
    var thumb = wrap.querySelector('[data-gs-mc-play]');
    var close = wrap.querySelector('[data-gs-mc-close]');
    if (thumb) thumb.hidden = false;
    if (close) close.hidden = true;
  };

  MaterialCheck.prototype.selectBlock = function (blockEl) {
    var answer = blockEl.getAttribute('data-gs-mc-answer');
    if (answer && this.config.answers[answer]) return this.go(this.config.answers[answer].question);
    var key = blockEl.getAttribute('data-gs-mc-result');
    if (key) {
      this.hideAll();
      blockEl.hidden = false;
      var material = this.config.materials[key];
      var text = blockEl.querySelector('[data-gs-mc-text]');
      if (text && material && material.advice) text.textContent = material.advice;
    }
  };

  MaterialCheck.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
  };

  var instances = new Map();

  function init(scope) {
    (scope || document).querySelectorAll('[data-gs-material-check]').forEach(function (root) {
      if (!instances.has(root)) instances.set(root, new MaterialCheck(root));
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-gs-material-check]').forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
      instances.delete(root);
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-gs-material-check]');
    var instance = root && instances.get(root);
    if (instance) instance.selectBlock(event.target);
  });

  window.GSMaterialCheck = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
